import HexController from 'controllers/hex_controller';
import { el } from 'modules/DOM';

export default class DesignModalFooterButtonController extends HexController {
  connect() {
    document.addEventListener('design-guidance-changed', this.designGuidanceChanged.bind(this));
    this.element.addEventListener('click', this.handleClick.bind(this));
  }

  disconnect() {
    document.removeEventListener('design-guidance-changed', this.designGuidanceChanged.bind(this));
  }

  designGuidanceChanged(event) {
    const { filePresent, testingGoalPresent } = event.detail;
    this.element.disabled = !(filePresent && testingGoalPresent);
  }

  _showFlashMessage() {
    const dismissFlashNotice = () => {
      window.flashNotice?.classList?.remove('appearing');
      setTimeout(() => {
        if (window.flashNotice) {
          window.flashNotice.remove();
          window.flashNotice = null;
        }
      }, 500);
    };

    window.flashNotice = el('div.flash-notice', {
      children: [
        el('div.flash-notice-icon', {
          children: [
            el('i.material-icons.check')
          ]
        }),
        el('div.flash-notice-content', {
          children: [
            el('span.flash-notice-title', this.t('AI Guidance Updated Successfully.')),
            el('span.flash-notice-text', this.t('You can now generate parameters and values using AI.'))
          ]
        }),
        el('button.flash-notice-close-btn', {
          events: {
            click: () => dismissFlashNotice(),
          },
          children: [
            el('i.material-icons.close')
          ]
        })
      ]
    });

    document.body.appendChild(window.flashNotice);
    setTimeout(() => window.flashNotice?.classList?.add('appearing'));
    setTimeout(() => dismissFlashNotice(), 3500);
  }

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.element.disabled) {
      // Show a confirmation flash message
      this._showFlashMessage();
    }

    Modalbox.hide();
  }
}
